var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuperscript = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.47 4.22 15 6.69V8h5V6.5h-2.69l1.22-1.22C19.3 4.51 20 3.571 20 2.5c0-.525-.171-1.137-.576-1.631C19 .35 18.35 0 17.5 0c-.85 0-1.5.35-1.924.869A2.614 2.614 0 0 0 15 2.5h1.5c0-.225.079-.488.237-.681.138-.17.363-.319.763-.319s.625.15.763.319c.158.193.237.456.237.681 0 .429-.3.99-1.03 1.72M6.809 9.5 1.956 2h2.382L8 7.66 11.662 2h2.382L9.191 9.5l4.853 7.5h-2.382L8 11.34 4.338 17H1.956z",
  clipRule: "evenodd"
})));
export default SvgSuperscript;